export enum TransactionStatusEnum {
  Init = 0,
  Proccess = 1,
  Success = 2,
  Failed = 3,
  Pending = 4,
  PaymentSuccess = 5,
  Timeout = 6,
  Deleted = 7,
  Refund = 8,
  Reject = 9
}

export enum TransactionTypeEnum {
  Normal = 0,
  User = 1,
  Partner = 2,
}
